export function maskEmail(email: string) {
  const [local = '', domain = ''] = email.split('@');
  if (!domain) return email;
  const a = local.at(0) ?? '';
  const b = local.at(-1) ?? '';
  const c = domain.at(0) ?? '';
  const d = domain.at(-1) ?? '';
  return `${a}***${b || a}@${c.toUpperCase()}***${d || c}`;
}

export const emailValid = (email: string) => {
  if (!email) return false;
  const emailRegex =
    /^[A-Z0-9](?:[A-Z0-9._%+-]*[A-Z0-9])?@[A-Z0-9](?:[A-Z0-9-]*[A-Z0-9])?(?:\.[A-Z0-9](?:[A-Z0-9-]*[A-Z0-9])?)+$/i;
  return emailRegex.test(email);
};
